// Maps backend role values to user-friendly display labels.
// Backend role strings are NOT changed — only what users see on screen.

const ROLE_DISPLAY: Record<string, string> = {
  'Distributor': 'Management Group User',
  'Distributor Admin': 'Management Group Admin',
  'Distributor Rep': 'Management Group Rep',
  'Org Admin': 'Organization Admin',
  'Org Rep': 'Organization Rep',
  'Client': 'Affiliate User',
  'Client Admin': 'Affiliate Admin',
  'Clinic Admin': 'Clinic Admin',
  'Clinic User': 'Clinic User',
};

export const displayRole = (role: string): string => ROLE_DISPLAY[role] || role;
